import React from 'react';
import tw from 'tailwind-styled-components';
import { useSelector } from "react-redux";

function Text3() {
    const user = useSelector((state) => state.UserReducer.user);
    return (
        <Main>
            <Heading>
                {user ? (
                    <>
                    Handpicked Just For You, <span className="text-kuality-blue">{user.first_name}!</span>
                    </>
                ) : (<>
                Personalized Picks!
                <div className="h-1 w-32 bg-kuality-blue mt-2 mx-auto rounded"></div>
                </>
                )}
            </Heading>
            <Subheading>{user? "Based on your preferences and style profile. We have something for everyone!"
                : "Discover our handpicked selection of top-quality products. We have something for everyone."}</Subheading>
        </Main>
    );
}

const Main = tw.div`container mx-auto px-4 my-5 md:my-10`;
const Heading = tw.div`text-3xl md:text-5xl font-bold text-center text-gray-800 my-2`;
const Subheading = tw.div`text-center text-gray-600 max-w-2xl mx-auto`;

export default Text3;